<template>
    <a class="wishlist-count" :href="urlWishList" :aria-label="$translate('Ceres::Template.wishList')">
        <span class="badge-right-count" v-if="wishListCount">{{wishListCount}}</span>
        <i class="fa" :class="{'fa-heart-o': !wishListCount, 'fa-heart': wishListCount}" aria-hidden="true"></i>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
